import {
    GetClockStationParameters_ChannelInfoDto,
    GetClockStationParameters_GetClockStationParametersResponse,
} from "../../../api";

export type Channel = GetClockStationParameters_ChannelInfoDto;

export type ClockArrowPosition = {
    hour: number;
    minute: number;
    seconds:number;
}

export type SecondaryClockParams = GetClockStationParameters_GetClockStationParametersResponse;


export type SecondaryClockProps = {
    deviceId: string;
    isAdmin: boolean;
    channels?: number;
}

export const clockFaceSrc = 'clock-face.svg?v=1.0';
export const hourHandSrc = 'hour-hand.svg?v=1.0';
export const minuteHandSrc = 'minute-hand.svg?v=1.0';
export const secondHandSrc = 'second-hand.svg?v=1.0';

export const MODEL_LIST = [
    '',
    'noname',
    'БК-МЧ-02',
    'БК-МЧ-03',
    'БК-МЧ-03+',
    'БК-МЧ-04',
    'БК-МЧ-С-03',
    'БК-МЧ-01',
    'БК-МЧ-04-С',
    'БК-МФЧ-03',
    'БК-МЧ-04+',
    'БК-МФЧ-С-04',
    'БК-МЧ-С-01',
    'БК-МФЧ-02',
    'БК-МФЧ-01',
    'БК-МФЧ-04',
    'БК-NU-90t'
]

export const MODEL_OPTIONS = MODEL_LIST.map(m => ({
    label: m,
    value: m
}));
